import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "First day with a new 2017 MacBook Pro",
  "description": "",
  "published": "2017-06-15T00:00:00.000Z",
  "redirect_from": ["/blog/first-day-new-2017-macbook-pro/swizec/7643"],
  "categories": "Business, Freelancing, Opinions, Personal, Side Projects",
  "hero": "./img/7vPupbf.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "ed2xrQt0Qp4",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`It's that time of the decade! I got a new laptop 🤘🏼`}</p>
    <p>{`Ordered `}<em parentName="p">{`during`}</em>{` WWDC last week, received yesterday, used for the first full workday today. My old laptop has been with me through thick and thin for almost 5 years, but it was time.`}</p>
    <p>{`Roadtrips, airplanes, bangs and drops, some spills ... Missing some screws, lacking a leg thing, crying for battery service for the past 2 years, so slow at encoding video it was dropping frames.`}</p>
    <p>{`Rest in peace MacBook Pro mid-2012. Long live MacBook Pro 2017!`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`I really wanted to hate the touchbar but my favorite writing app has a beautiful integration. `}<a parentName="p" {...{
          "href": "https://t.co/PBTdl0Xn2m"
        }}>{`pic.twitter.com/PBTdl0Xn2m`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/874990108813926400"
      }}>{`June 14, 2017`}</a></blockquote>
    <p>{`I really wanted to hate the Touchbar. The whole internet said it was stupid, reviewers said it was stupid, it `}<em parentName="p">{`felt`}</em>{` stupid just thinking about it.`}</p>
    <p>{`Yet Apple wouldn't sell me a top-spec laptop without the stupid Touchbar. So a Touchbar I paid for.`}</p>
    <p>{`And holy shit is that thing amazing!`}</p>
    <p>{`Maybe apps have caught up, maybe everyone just loved hopping on the hate Apple bandwagon, I don't know. All I can say is that after a single day with my laptop, I am in love with the Touchbar.`}</p>
    <p>{`Yes, I never use it for `}<em parentName="p">{`work`}</em>{` work.`}</p>
    <p>{`Yes, my laptop is closed in clamshell mode 80% of the time.`}</p>
    <p>{`Yep, I'm using an external clicky keyboard and mouse and big monitor.`}</p>
    <p>{`Yeah, it feels stupid that you have to look at your keyboard to use the Touchbar.`}</p>
    <p>{`I want one for my external mechanical keyboard anyway. It's that good. Bloody thing is amazing. As much as I hate to admit it, I love it.`}</p>
    <p>{`So far I've found it most useful for typing emojis, changing and scrobbling songs on Spotify, and opening man pages.`}</p>
    <p>{`Wait what`}</p>
    <p>{`Yep, there's Terminal integration. A `}<inlineCode parentName="p">{`man page`}</inlineCode>{` button shows up that opens the man page for whatever is in your prompt.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Ok fuck it Touchbar wins. This thing is amazing `}<a parentName="p" {...{
          "href": "https://t.co/iYaAcLEMV1"
        }}>{`pic.twitter.com/iYaAcLEMV1`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/875157119447711744"
      }}>{`June 15, 2017`}</a></blockquote>
    <p>{`I didn't even know man pages were a feature in Terminal until the Touchbar showed me! That's what I love about it. As an app designer you could really leverage this thing to help people discover features in your app.`}</p>
    <p>{`My favorite writing tool uses it for markdown shortcuts. I definitely use keyboard shortcuts for that, but the magic buttons are neat.`}</p>
    <p>{`Imagine Emacs integration that lists open files in the Touchbar for fast access. Wouldn't that be cool? Safari does it for tabs.`}</p>
    <p>{`No Chrome integration tho ... Google doesn't give a shit about the Touchbar 😔`}</p>
    <h2 {...{
      "id": "general-impressions"
    }}>{`General Impressions`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e972ca61554ffb9d2c894b1801b3b91e/4b190/7vPupbf.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2041c0%2044%200%2042%206%2042l2%201-2%201c-6%200-6-4-6%2060v59l3-5a1255%201255%200%200033-62%202277%202277%200%200134-65c0-3-2-2-2%200%201%201%200%202-1%204v-1c0-2%200-2-1-1-2%202-5%202-11-1-6-2-7-3-7-7-1-4-3-5-5-3h-1l-1-2-2-2c0-4-6-4-6-1-1%201-1-5-1-12l-1-14c-2%200-2-1-2-4l-1-4c-2%200-2-1-2-4l-1-4-1%204-1%204c-2%200-2-2-2-8l-1-8c-2%200-2-1-2-4V0H0v41M121%201l-1%205-2%206c-3%202-3%204%201%204%203%200%204-1%205-2l1-2c1%200%204-3%204-5h-1l-3%201h-2l3-3c3-2%207-2%2011%201%203%201%203%204-1%207l-4%203-3%202-5%202a2282%202282%200%2001-6%204c-5%202%2010%203%2074%203%2060%200%2071%200%2062-3l-1-1c1-1%202-1%205%201l5%202h55l69-2h13V0H261L121%201m-7%2034c-2%200-7%209-7%2012l-1%201-2%203-8%2017a9423%209423%200%2000-19%2041c-3%206-3%208-3%2012l1%209c0%205-1%205%2082%205h76l19-3a4448%204448%200%200187-15c1-1-3-3-5-3l-5-2-3-3c-1%200-6-8-6-10l-1-3c-2%200-4-7-3-8v-2l-3-5-5-12-1-4a180%20180%200%2000-17-30H114m-48%207c-2%202-3%203-5%202l-6%202-5%203-3%201c-2%202%203%203%206%202%208-4%2015-3%2018%204l2%203c2%200%202-2%201-5-3-3-2-3%200-5%203-1%203-2%200-4l-4-3-3-2-1%202m123%200l-2%202-3%201c-6%200%200%202%2010%203s11%201%2014-2l5-2v-1c-1-2-21-2-24-1m-70%2014l-2%201c1%201%206%202%2018%202%2014%200%2020%200%2035%203l32%205%2013%201%205-2c5-3%205-3-11-5h-15c-3%202-6%202-24-1-22-4-46-6-51-4m131%207l-8%208h8c10%200%2014%202%2014%205l1%201v1h1c2-1%202-2%201-2v-1h2l1-2%201-2h1c0%201%202%200%203-2%203-3%204-5%203-7%200-5-2-6-11-7h-8l-9%208m0%2010v1l-1%202c-1%202-15%2011-23%2014a11094%2011094%200%2000-24%2012l3%201c3%202%2010-1%2013-4a105%20105%200%200122-12l7-5c7-4%209-6%207-8v-1c1-1%200-1-2-1l-2%201m-134%2041c3%201%201%201-7%201-11%200-24%201-28%203v1a5784%205784%200%2000227-2l-18-1h-4l-47-1-45-1a478%20478%200%2000-78%200m244%2022c-5%201-4%202%204%206%206%204%207%204%2011%203%202%200%203-1%201-1-1%200-2-1-2-3-1-6-5-7-14-5M67%20170l1%205v6c-1%203%201%209%203%2011l5%2010%205%208%204%207%202%202%202%204c1%202%202%202%208%202l8-1-10-15c-28-44-27-41-28-39m91%202l-4%202-1%202v1c2%200%203%201%201%203s0%202%203%200c4-2%207-2%204%201v2c3%200%204-1%205-5v-3h3l2-1c0-3-5-3-13-2m93%2013l-12%201c-10-1-13%200-8%202%202%201%203%201%202%202-1%203-3%203-12%202-10%200-13%201-13%205s4%204%2010%201%2013-3%2019%200c8%205%208%207%200%2011l-7%203%201%204c1%202%201%202-1%204-1%201-1%201%202%201h4l-1%201v1h1l1%201c0%202%208%201%2011-1%204-2%2011-13%2011-16s-3-8-6-12c-6-5-6-7-1-8%204%200%208-3%204-3l-5%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e972ca61554ffb9d2c894b1801b3b91e/ca0a1/7vPupbf.webp 223w", "/static/e972ca61554ffb9d2c894b1801b3b91e/75680/7vPupbf.webp 445w", "/static/e972ca61554ffb9d2c894b1801b3b91e/d00b9/7vPupbf.webp 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e972ca61554ffb9d2c894b1801b3b91e/853b2/7vPupbf.jpg 223w", "/static/e972ca61554ffb9d2c894b1801b3b91e/0a4fe/7vPupbf.jpg 445w", "/static/e972ca61554ffb9d2c894b1801b3b91e/4b190/7vPupbf.jpg 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e972ca61554ffb9d2c894b1801b3b91e/4b190/7vPupbf.jpg",
                "alt": "New laptop and old laptop",
                "title": "New laptop and old laptop",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`New laptop and old laptop`}</figcaption>{`
  `}</figure></p>
    <p>{`New laptop and old laptop`}</p>
    <p>{`Other than the Touchbar, the computer is very ... well you know. It's been 5 years since my previous new computer and I'm surprised by how little progress there has been.`}</p>
    <p>{`Fancy new laptop. Full Webpack build of our project at work is 30 second faster. That's the biggest effect so far. 30 seconds off of compile time.`}</p>
    <p>{`In general everything feels a little snappier but not enough to put a finger on it. Video encoding is marginally faster and doesn't turn on the fans. Boot times are the same. File copying is fast but not holy shit fast. 10 seconds to copy 1.3 gigs ¯`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <p>{`I mean yeah, everything is a little snappier, a bit quicker to respond and run animations. But it just doesn't feel like 5 years worth of a difference.`}</p>
    <p>{`Remember how big a difference there was between a computer in 1996 and a computer in 2001? Those were worlds apart.`}</p>
    <p>{`This one feels like a spick of polish on top of my old machine. It doesn't even have more RAM.`}</p>
    <h2 {...{
      "id": "things-i-hate"
    }}>{`Things I hate`}</h2>
    <p>{`The dongles. Holy shit the dongles. That stuff needs to go die in a fire.`}</p>
    <p>{`Yes I get it, USB-C is the future. We're all gonna have all the things with USB-C in 5 years. `}<em parentName="p">{`I'm gonna have a new laptop by then`}</em>{` 😡`}</p>
    <p>{`I didn't even notice when Apple killed the CD. Or when they killed the Ethernet port. By the time Apple killed those, nobody was using them anymore.`}</p>
    <p>{`But USB? All my stuff is USB. Literally everything, I'm not even joking.`}</p>
    <p>{`Mouse, keyboard, camera, phone, backup drive, everything USB. Sure I can connect them via my monitor, `}<em parentName="p">{`but I can't even connect my monitor`}</em>{`.`}</p>
    <p>{`Oh, your monitor is Thunderbolt 2, not USB-C? Tough. You can buy a $50 dongle. A dongle for my dongle 🙄`}</p>
    <p>{`To add insult to injury, the new charger is incompatible with my monitor's charging cable `}<strong parentName="p">{`and`}</strong>{` with my existing chargers. Hello zero redundancy!`}</p>
    <p>{`New Apple chargers come in "brick with USB-C port" form. There's a USB-C to USB-C cable that you use to connect your laptop.`}</p>
    <p>{`Now I have to cary my charger around like a peasant. That shit's heavy!`}</p>
    <p>{`I Guess it's time to look for a new monitor. One that charges and connects through the same cable. Those exist, right? Proper docking stations for a modern laptop ... one can hope.`}</p>
    <p>{`Here's to the next 5 years. 🍻`}</p>
    <p>{`PS: TouchID is a pain in the arse in clamshell mode. Gotta open your laptop, smash your finger on the reader, close laptop every time it locks. Lame.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      